import { forwardRef } from 'react';
import { Button, type ButtonProps } from '@/components/shadcn/default/button';
import { cn } from '@/lib/utils';

export const PrimaryButton = forwardRef<HTMLButtonElement, ButtonProps>(({ ...props }, ref) => {
  return (
    <Button
      ref={ref}
      {...props}
      className={cn(
        'border-shade-medium-default bg-secondary-dark-default text-shade-white-default flex items-center justify-center gap-1 rounded-full border text-base font-medium disabled:border-[#D5DEDE] disabled:bg-[#F7F8F8] disabled:text-[#B7C9C9]',
        props.className,
      )}
    >
      {props.children}
    </Button>
  );
});
PrimaryButton.displayName = 'PrimaryButton';

export const SecondaryButton = forwardRef<HTMLButtonElement, ButtonProps>(({ ...props }, ref) => {
  return (
    <Button
      ref={ref}
      {...props}
      className={cn(
        'bg-shade-white-default text-secondary-xdark-default flex items-center justify-center gap-1 rounded-full border border-[var(--secondary-background-xmedium-hover)] text-base font-medium',
        props.className,
      )}
    >
      {props.children}
    </Button>
  );
});
SecondaryButton.displayName = 'SecondaryButton';

export const ErrorButton = ({ ...props }: ButtonProps) => {
  return (
    <Button
      {...props}
      className={cn(
        'bg-shade-white-default border--[#DC0000] flex items-center justify-center gap-1 rounded-full border text-base font-medium text-[#DC0000]',
        props.className,
      )}
    >
      {props.children}
    </Button>
  );
};
